import { hasActiveSubscription } from "@/application/helpers/check-subscription";
import { UserQueries } from "@/application/queries/user.queries";
import { AuthService } from "@/application/services/user/auth.service";
import PageLoader from "@/interface/pages/page-loader";
import { SubscriptionPage } from "@/interface/pages/subscriptions/subscription-page";
import { QueryClient } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";

const handleUnathenticatedAccess = (location?: string) => {
  throw redirect({
    to: "/auth/login",
    search: {
      from: location,
    },
  });
};

export const Route = createFileRoute("/users/subscription/plans")({
  component: RouteComponent,
  loader: async () => {
    const queryClient = new QueryClient();
    await queryClient.ensureQueryData({
      staleTime: Infinity,
      ...UserQueries.getCurrent(),
    });

    const alreadySubscribed = await hasActiveSubscription({
      allowFreeTrial: false,
    });
    if (alreadySubscribed) {
      throw redirect({
        to: "/users/home",
      });
    }
  },
  staleTime: Infinity, // Keep the data cached for the lifetime of the app
  onError: () => handleUnathenticatedAccess(),
  pendingComponent: PageLoader,
  beforeLoad: ({ location }) => {
    const isAuthenticated = AuthService.getAuthenticatedState();
    if (!isAuthenticated) {
      throw handleUnathenticatedAccess(location.href);
    }
  },
});

function RouteComponent() {
  return <SubscriptionPage />;
}
